<template>
  <footer class="footer">
    <Container>
      <div class="footer-inner">
        <div class="footer-top">
          <NuxtLink no-prefetch  to="/" class="footer-logo"></NuxtLink>
          <div class="footer-contacts">
            <h3 class="footer-title footer-title-bizi">Bizi</h3>
            <ul class="footer-list">
              <li>
                <NuxtLink no-prefetch  to="/about-us" class="footer-link">{{
                  $t('aboutUs')
                }}</NuxtLink>
              </li>
              <!-- <li>
                <NuxtLink no-prefetch  to="/" class="footer-link">{{
                  $t('contacts')
                }}</NuxtLink>
              </li> -->
              <li>
                <NuxtLink no-prefetch  to="/faq" class="footer-link">FAQ</NuxtLink>
              </li>
            </ul>
          </div>
          <div class="footer-business">
            <h3 class="footer-title">
              {{ $t("businessIn") }}
              <span class="footer-title-bizi">bizi</span>
            </h3>
            <ul class="footer-list">
              <li>
                <NuxtLink no-prefetch  to="/for-business" class="footer-link">{{
                  $t('forBusiness')
                }}</NuxtLink>
              </li>
              <li>
                <NuxtLink no-prefetch  to="/paid-services" class="footer-link">{{
                  $t('paidServices')
                }}</NuxtLink>
              </li>
              <li>
                <NuxtLink no-prefetch  to="/company-details" class="footer-link">{{
                  $t('companyDetails')
                }}</NuxtLink>
              </li>
            </ul>
          </div>
          <div class="footer-support">
            <h3 class="footer-title">{{ $t("support") }}</h3>
            <ul class="footer-list">
              <li>
                <NuxtLink no-prefetch  to="/privacy-policy" class="footer-link">{{
                  $t('privacyAgreement')
                }}</NuxtLink>
              </li>
              <li>
                <NuxtLink no-prefetch  to="/terms-of-use" class="footer-link">{{
                  $t('termsOfUse')
                }}</NuxtLink>
              </li>
              <li>
                <NuxtLink no-prefetch  to="/help-feedback" class="footer-link">{{
                  $t('helpAndFeedback')
                }}</NuxtLink>
              </li>
            </ul>
          </div>
          <div class="footer-socials">
            <h3 class="footer-title">{{ $t("weOnSocials") }}</h3>
            <ul class="footer-list">
              <!-- <li>
                <NuxtLink no-prefetch  to="/" class="footer-link footer-link-fb"
                  >Facebook</NuxtLink
                >
              </li> -->
              <li>
                <NuxtLink no-prefetch  to="https://www.instagram.com/bizione/" target="_blank" class="footer-link footer-link-insta"
                  >Instagram</NuxtLink
                >
              </li>
              <!-- <li>
                <NuxtLink no-prefetch  to="/" class="footer-link footer-link-youtube"
                  >Youtube</NuxtLink
                >
              </li> -->
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="footer-address">{{currentYear}} Bizi, INC</div>
        </div>
      </div>
    </Container>
  </footer>
</template>

<script lang="ts" setup>
import moment from "moment";

const currentYear = moment().year();
</script>

<style lang="scss" scoped>
.footer {
  background-color: #101519;
}

.footer-logo {
  display: block;
  width: 170px;
  height: 82px;
  background: url('../../assets/logo.svg') no-repeat center / contain;
}

.footer-inner {
  display: flex;
  flex-direction: column;
  padding: 45px 0;
}

.footer-top {
  border-bottom: 1px solid var(--Text-500);
  display: flex;
  justify-content: space-between;
  padding-bottom: 34px;
  flex-wrap: wrap;
}

.footer-title {
  font-size: 20px;
  line-height: 28px;
  color: white;
  margin: 0 0 var(--spacing_12);

  &-bizi {
    text-transform: uppercase;
  }
}

.footer-list {
  display: flex;
  flex-direction: column;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: var(--spacing_8);
    font-size: 16px;
    line-height: 24px;
  }
}

.footer-link {
  color: var(--Text-500);
  text-decoration: none;
}

.footer-bottom {
  padding-top: var(--spacing_16);
}

.footer-address {
  color: var(--Accent-White);
  font-size: var(--spacing_16);
}

.footer-link-fb {
  padding-left: 30px;
  background-image: url('../../assets/fb-icon-gray.svg');
  background-repeat: no-repeat;
  background-position: left center;
}

.footer-link-insta {
  padding-left: 30px;
  background-image: url('../../assets/insta-icon-gray.svg');
  background-repeat: no-repeat;
  background-position: left center;
}

.footer-link-youtube {
  padding-left: 30px;
  background-image: url('../../assets/youtube-icon.svg');
  background-repeat: no-repeat;
  background-position: left center;
}

// Responsive Styles
@media screen and (max-width: 1200px) {
  .footer-top {
    flex-wrap: wrap;
  }
  
  .footer-top > div {
    width: 48%;  // Ensure the footer columns take up less space and wrap
    margin-bottom: 20px;
  }

  .footer-logo {
    width: 140px;
    height: 70px;
  }
}

@media screen and (max-width: 850px) {
  .footer-logo {
    display: none; // Hide the logo on smaller screens
  }

  .footer-top {
    flex-direction: column;
    align-items: center;  // Center align the columns
    text-align: center;   // Center align the text
  }

  .footer-title {
    font-size: 18px;
  }

  .footer-list li {
    font-size: 14px;
  }

  .footer-list {
    margin-bottom: 20px;
  }

  .footer-bottom {
    text-align: center;
    margin-bottom: 50px;
  }
}

@media screen and (max-width: 650px) {
  .footer-inner {
    padding: 15px 0;
  }

  .footer-list {
    font-size: 14px;
  }

  .footer-address {
    font-size: 14px;
  }
}

</style>
